import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { Paper, Typography, Skeleton, Box } from '@mui/material';
import { formatMoney } from '../../../utils/currency';

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  const { name, average, color } = payload[0].payload;

  return (
    <Box
      bgcolor="white"
      p={1.5}
      boxShadow={2}
      borderRadius={1}
      border={`1px solid ${color}`}
    >
      <Typography variant="subtitle2" gutterBottom>
        {name}
      </Typography>
      <Typography variant="body2" sx={{ color }}>
        💰 Promedio: {formatMoney(average)}
      </Typography>
    </Box>
  );
};

const AverageSalesByBranchChart = ({ data = [], branches = [], loading }) => {
  const formattedData = data.map((item) => {
    const branch = branches.find((b) => b.id === item.branchId);
    return {
      ...item,
      name: branch ? (branch.deleted ? `${branch.name} (eliminada)` : branch.name) : `Sucursal ${item.branchId}`,
      deleted: !!branch?.deleted,
      color: branch?.color || '#1976d2',
    };
  });

  return (
    <Paper elevation={2} sx={{ height: 360, p: 2 }}>
      <Typography variant="subtitle1" gutterBottom>
        Ticket promedio por sucursal
      </Typography>

      <Box sx={{ width: '100%', height: 300 }}>
        {loading ? (
          <Skeleton variant="rectangular" width="100%" height={300} />
        ) : formattedData.length > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={formattedData}
              margin={{ top: 20, right: 20, bottom: 0, left: 0 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip content={<CustomTooltip />} />
              <Bar dataKey="average">
                {formattedData.map((entry, index) => (
                  <Cell key={index} fill={entry.color} fillOpacity={entry.deleted ? 0.4 : 1} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" color="textSecondary">
              No hay datos disponibles.
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default AverageSalesByBranchChart;
